import { BaseEntity } from '../../../xform-compat';
import { BasicUser } from '../basicUser.model';
import { CompanyTotals } from './company-totals.interface';
import { Synonym } from './synonym';
import { CompanyBusinessAlert } from './company-business-alert';
import { Tenant } from '../tenant.model';
import { CourtshipTypeEnum } from '../../enums/courtship-type.enum';
import { Domain } from '../domain.model';
import { CompanyAggregatePosition } from './company-aggregate-position.model';
import { CompanySecurity } from './company-security.model';
import { CompanyInfo } from './company-info.model';


export class CompanyBasic implements BaseEntity {
  id: number;
  adquiredById: number;
  synonyms: Array<Synonym>;
  active: boolean;
  createdBy: BasicUser;
  followed: boolean;
  name: string;
  description?: CompanyInfo;
  isPrivate: boolean;
  totals: CompanyTotals;
  isAcquisitionAnnounced: boolean;
  allowHeadlines: boolean;
  isHSR: boolean;
  nameSelected?: string;
  acquiredBy?: any;
  // Nested, from CompanyResource on the company page.
  acquisitionAnnouncedBy?: any;
  // Flat id only, from SimpleCompanyResource on a portfolio row. The two sources
  // fill different fields; neither fills both.
  acquisitionAnnouncedById?: number;
  // Flat id from SimpleCompanyResource, used by the portfolio ACQ A. guard. Distinct from the
  // misspelled `adquiredById` that the autocomplete's CompanyIndex returns.
  acquiredById?: number;
  ticker?: string;
  change?: number;
  currency?: string;
  businessAlertSubscriptions?: Array<CompanyBusinessAlert>;
  tenant: Tenant | number;
  courtshipType?: CourtshipTypeEnum;
  seniorAttention?: boolean;
  domains?: Array<Domain>;
  aggregatePosition: CompanyAggregatePosition;
  defaultContentRootId: number;
  activeCrmItemIds: Array<number>;
  subdomain: string;
  platform: string;
  mapsForLead: string;
  securities: Array<CompanySecurity>;

  constructor(data?: Partial<CompanyBasic>) {
    this.id = data.id || null;
    this.active = data.active || null;
    this.name = data.name || '';
    this.description = data.description || null;
    this.isPrivate = data.isPrivate || null;
    this.followed = data.followed || null;
    this.totals = data.totals || {alerts: null, contacts: null, headlines: null};
    this.businessAlertSubscriptions = data.businessAlertSubscriptions || [];
    this.isAcquisitionAnnounced = data.isAcquisitionAnnounced || false;
    this.acquisitionAnnouncedBy = data.acquisitionAnnouncedBy || null;
    this.acquisitionAnnouncedById = data.acquisitionAnnouncedById || null;
    this.acquiredById = data.acquiredById || null;
    this.allowHeadlines = data.allowHeadlines !== false;
    this.isHSR = data.isHSR  || false;
    this.courtshipType = data.courtshipType || CourtshipTypeEnum.NONE;
    this.seniorAttention = data.seniorAttention || false;
    this.aggregatePosition = data.aggregatePosition ? new CompanyAggregatePosition(data.aggregatePosition) : null;
    this.currency = data.currency || null;
    this.defaultContentRootId = data.defaultContentRootId || null;
    this.activeCrmItemIds = data.activeCrmItemIds || null;
    this.subdomain = data.subdomain || null;
    this.platform = data.platform || null;
    this.mapsForLead = data.mapsForLead || null;
    this.securities = data.securities || null;
  }
}
